import { fmtEUR } from '../../shared/format';
import CalmStatCard from '../transactions/CalmStatCard';

export default function ForecastStatsRow({ forecast }) {
  const forecastPositive = forecast.forecastBalance >= 0;
  const pendingCredits = forecast.pending.filter((p) => p.type === 'credit').length;
  const pendingDebits = forecast.pending.filter((p) => p.type === 'debit').length;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.6fr) minmax(0, 1fr) minmax(0, 1fr)',
        gap: 'var(--stats-gap)',
        marginBottom: 'var(--stats-row1-mb)',
      }}
      className="forecast-stats-row"
    >
      <CalmStatCard
        label="Solde prévisionnel fin de mois"
        value={fmtEUR(forecast.forecastBalance, { sign: forecast.forecastBalance < 0 })}
        tone={forecastPositive ? 'credit' : 'debit'}
        big
        featured
        hint={`Actuellement ${fmtEUR(forecast.currentBalance, { sign: forecast.currentBalance < 0 })}`}
      />
      <CalmStatCard
        label="Entrées restantes"
        value={'+ ' + fmtEUR(forecast.pendingCredit)}
        tone="credit"
        meta={
          pendingCredits > 0
            ? [{ value: String(pendingCredits), label: 'à recevoir' }]
            : undefined
        }
        hint={pendingCredits === 0 ? 'Aucune entrée à recevoir' : undefined}
      />
      <CalmStatCard
        label="Sorties restantes"
        value={'− ' + fmtEUR(forecast.pendingDebit)}
        tone="debit"
        meta={
          pendingDebits > 0
            ? [{ value: String(pendingDebits), label: 'à payer' }]
            : undefined
        }
        hint={pendingDebits === 0 ? 'Plus rien à payer' : undefined}
      />
    </div>
  );
}
